import { useEffect, useRef } from 'react';

export function useAutoHideMessage(
    message: string | null,
    clear: () => void,
    delay = 5000,
) {
    const clearRef = useRef(clear);
    useEffect(() => { clearRef.current = clear; });

    useEffect(() => {
        if (!message) return;
        const timer = setTimeout(() => clearRef.current(), delay);
        return () => clearTimeout(timer);
    }, [message, delay]);
}